import { ProgressBar } from '@shopify/polaris';
import * as React from 'react';

export default function LoadingBar({ durationInSeconds = 10 }: { durationInSeconds?: number }) {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        return oldProgress + 1;
      });
    }, durationInSeconds * 10);

    return () => clearInterval(interval);
  }, []);

  return <ProgressBar progress={progress} />;
}
